/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const payginePaymentCallbackRequestSchema = z.object({
	order_id: z.string().min(1),
	order_state: z.string().min(1),
	type: z.string().min(1),
	signature: z.string().min(1),
});
